import * as React from "react";

import { Link } from "common/types/routing";

import GuestNavbar from "./guest-navbar";

type Props = {
  children: React.ReactNode;
  linkToSignIn: Link;
  linkToSignUp: Link;
};

export default function AnonymousPageLayout({
  children,
  linkToSignIn,
  linkToSignUp
}: Props) {
  return (
    <>
      <GuestNavbar linkToSignIn={linkToSignIn} linkToSignUp={linkToSignUp} />
      {children}
    </>
  );
}
